<header mat-dialog-title>
    <div class="dialog-header">
        <!-- Si es el modal de Registrar novedad general -->
        <h3 *ngIf="vista === 'novedades'; else autorizaciones" class="mat-h2">Registrar novedad general</h3>
        <!-- Si es el modal de Registrar autorización presencial -->
        <ng-template #autorizaciones>
            <h3 class="mat-h2">Registrar autorización presencial</h3>
        </ng-template>
        <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
    </div>
</header>

<div class="table-tools" style="padding-left: 0; padding-right: 0;">

    <mat-form-field appearance="outline" class="full-width">
        <mat-label>Filtrar por nombre</mat-label>
        <input matInput placeholder="Nombre" (keyup)="filtroTexto($event.target.value)" autocomplete="off">
    </mat-form-field>


    <mat-form-field appearance="outline" class="full-width">
        <mat-label>Filtrar por curso</mat-label>
        <mat-select placeholder="Filtrar curso" (selectionChange)="filtroCurso($event.value)">
            <mat-option value="">Todos</mat-option>
            <ng-container *ngFor="let curso of cursos | async">
                <ng-container *ngFor="let cursoDetalle of curso.cursos">
                    <mat-option [value]="cursoDetalle.id">{{cursoDetalle.nombre}}</mat-option>
                </ng-container>
            </ng-container>
        </mat-select>
    </mat-form-field>

</div>

<div style="height: calc(100% - 216px); overflow: auto" class="full-width mat-elevation-z2">
    <mat-table #table [dataSource]="_alumnos" matSort>
        <ng-container matColumnDef="Alumno" sticky="true">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="student-col">Alumno</mat-header-cell>
            <mat-cell *matCellDef="let element" class="student-col" style="height: 108px;">
                <div>
                    <div>
                        <p><strong>{{element.alumno.apellidosNombres}}</strong></p>
                        <mat-icon *ngIf="element.isAusenciaConsecutiva" color="warn" class="md-14" matTooltip="Tres o más ausencias consecutivas" style="cursor:help;">warning
                        </mat-icon>
                    </div>
                    <app-autorizacion-presencial [alumno]="element.alumno" [autorizaciones]="element.autorizaciones" style="margin: 8px;margin-left: 8px;margin-left: 0;"></app-autorizacion-presencial>
                </div>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Curso">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="grade-col">Curso</mat-header-cell>
            <mat-cell *matCellDef="let element" class="grade-col">{{element.curso.nombre}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="Retardo">
            <mat-header-cell *matHeaderCellDef class="other-col">Retardo</mat-header-cell>
            <mat-cell *matCellDef="let element" class="other-col">
                <p style="text-align: center">
                    <mat-checkbox [checked]="(tiposAsistencia | filtroID: element.asistencia.tipoID).codigo.indexOf('R') > -1" (change)="setEstado($event.checked, element, retardo)"></mat-checkbox>
                </p>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Ausencia">
            <mat-header-cell *matHeaderCellDef class="other-col">Ausencia</mat-header-cell>
            <mat-cell *matCellDef="let element" class="other-col">
                <p style="text-align: center">
                    <mat-checkbox [checked]="(tiposAsistencia | filtroID: element.asistencia.tipoID).codigo.indexOf('A') > -1" (change)="setEstado($event.checked, element, ausencia)"></mat-checkbox>
                </p>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="En casa">
            <mat-header-cell *matHeaderCellDef class="other-col">En casa</mat-header-cell>
            <mat-cell *matCellDef="let element" class="other-col">
                <p style="text-align: center">
                    <mat-checkbox [checked]="(tiposAsistencia | filtroID: element.asistencia.tipoID).codigo.indexOf('PC') > -1" (change)="setEstado($event.checked, element, enCasa)"></mat-checkbox>
                </p>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Permiso">
            <mat-header-cell *matHeaderCellDef class="other-col">Permiso</mat-header-cell>
            <mat-cell *matCellDef="let element" class="other-col">
                <p style="text-align: center">
                    <mat-checkbox [checked]="element.asistencia.tipoID === 12 || element.asistencia.isPermiso" (change)="setEstado($event.checked, element, {id: 0, nombre: 'permiso'})"></mat-checkbox>
                </p>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="FechaInit">
            <mat-header-cell *matHeaderCellDef class="date-col">Fecha inicial</mat-header-cell>
            <mat-cell *matCellDef="let element" class="date-col">
                <mat-form-field *ngIf="element.asistencia.id !== 0" appearance="outline" class="full-width">
                    <input (dateChange)="setEstado($event, element, {id: 0, nombre: 'fechaInicia'})" matInput [matDatepicker]="picker" [value]="element.asistencia.fechaAsistencia">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="FechaFin">
            <mat-header-cell *matHeaderCellDef class="date-col">Fecha final</mat-header-cell>
            <mat-cell *matCellDef="let element" class="date-col">
                <mat-form-field *ngIf="element.asistencia.id !== 0" appearance="outline" class="full-width">
                    <input (dateChange)="setEstado($event, element, {id: 0, nombre: 'fechaFin'})" matInput [matDatepicker]="picker2" [value]="element.asistencia.fechaAsistenciaFin">
                    <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                    <mat-datepicker #picker2></mat-datepicker>
                </mat-form-field>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Observacion" sticky="true">
            <mat-header-cell *matHeaderCellDef class="comment-col">Observación</mat-header-cell>
            <mat-cell *matCellDef="let element" class="comment-col" style="min-width: 257px;">
                <mat-form-field class="full-width" appearance="outline">
                    <textarea matInput placeholder="Observación" [(ngModel)]="element.asistencia.comentario" [disabled]="element.asistencia.id == 0" (keyup)="setComentario(element)"></textarea>
                </mat-form-field>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="fecha">
            <mat-header-cell *matHeaderCellDef class="date-col">Fecha</mat-header-cell>
            <mat-cell *matCellDef="let element" class="date-col">
                <mat-form-field appearance="outline">
                    <mat-label>Seleccione una fecha</mat-label>
                    <input (dateChange)="guardarAutorizacion($event.value, element)" matInput [matDatepicker]="picker3">
                    <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
                    <mat-datepicker #picker3></mat-datepicker>
                </mat-form-field>
            </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>
    <mat-paginator #paginator [pageSize]="20" [pageSizeOptions]="[5, 10, 20]" [showFirstLastButtons]="true">
    </mat-paginator>
</div>
<div style="padding-top: 16px; align-content: center;">
    <button color="primary" mat-raised-button (click)="closeDialog()" [disabled]="saving">Finalizar</button>
</div>
